import type { FC } from "react";
import UserCubit, {
  ProfileAttributesKeys
} from "src/state/UserCubit/UserCubit";
import { useBloc } from "src/state/state";
import {
  DebugBadge,
  DebugButton,
  DebugFormGroup,
  DebugKeyValue
} from "./debug.styles";

const EXPERIENCE_GROUPS = [
  { value: "", label: "— None —" },
  { value: "HWJ_ON_GLP1_CONTINUATION", label: "HWJ - On GLP1 Continuation" },
  {
    value: "HWJ_ON_GLP1_CONTINUATION_NO_CONCIERGE_CARE",
    label: "HWJ - On GLP1 (No Concierge)"
  },
  { value: "HWJ_ELIGIBLE_FOR_MEDS", label: "HWJ - Eligible for Meds" },
  { value: "HWJ_NOT_ELIGIBLE_FOR_MEDS", label: "HWJ - Not Eligible for Meds" },
  { value: "EDJ_ON_GLP1_CONTINUATION", label: "EDJ - On GLP1 Continuation" },
  {
    value: "DIABETES_AND_HEART_DISEASE_PREVENTION_OR_ALL_IN_ONE",
    label: "Diabetes and Heart Disease Prevention or All-in-One"
  },
  { value: "", label: "Empty (not set)" }
] as const;

const DebugExperienceGroup: FC = () => {
  const [{ profileAttributes }, cubit] = useBloc(UserCubit);
  const currentGroup =
    profileAttributes?.[ProfileAttributesKeys.experienceGroup];

  const isHwjOrEdj =
    currentGroup?.startsWith("HWJ_") ?? currentGroup?.startsWith("EDJ_");

  const handleChange = (value: string) => {
    cubit.emit({
      ...cubit.state,
      profileAttributes: {
        ...(cubit.state.profileAttributes ?? {}),
        [ProfileAttributesKeys.experienceGroup]: value || undefined
      } as typeof cubit.state.profileAttributes
    });
  };

  const handleRefresh = async () => {
    await cubit.getProfileAttributes();
  };

  return (
    <div>
      <DebugKeyValue>
        <span className="key">Current Group</span>
        <span className="value">
          {currentGroup ? (
            <DebugBadge variant={isHwjOrEdj ? "success" : "warning"}>
              {currentGroup}
            </DebugBadge>
          ) : (
            <DebugBadge variant="info">Not set</DebugBadge>
          )}
        </span>
      </DebugKeyValue>

      <DebugKeyValue>
        <span className="key">Coaching Card</span>
        <span className="value">
          {isHwjOrEdj ? (
            <DebugBadge variant="success">Visible</DebugBadge>
          ) : (
            <DebugBadge variant="warning">Hidden</DebugBadge>
          )}
        </span>
      </DebugKeyValue>

      <DebugFormGroup style={{ marginTop: "0.75rem" }}>
        <label>Override Experience Group (local only)</label>
        <select
          value={currentGroup ?? ""}
          onChange={(e) => handleChange(e.target.value)}
        >
          {EXPERIENCE_GROUPS.map((group) => (
            <option key={group.value} value={group.value}>
              {group.label}
            </option>
          ))}
        </select>
      </DebugFormGroup>

      <DebugButton
        className="small"
        style={{ marginTop: "0.5rem" }}
        onClick={() => void handleRefresh()}
      >
        Refresh from Server
      </DebugButton>
    </div>
  );
};

export default DebugExperienceGroup;
